import React, { CSSProperties, useEffect, useState } from "react";

const GRAVATAR_URL = "https://www.gravatar.com/avatar/" as const;

/** Gravatar identifies an email by the SHA-256 of its trimmed, lowercase form. */
const hashEmail = async (email: string) => {
  const data = new TextEncoder().encode(email.trim().toLowerCase());
  const digest = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
};

const getUrl = ({ hash = "", size }: { hash?: string; size: number }) =>
  `${GRAVATAR_URL}${hash}?s=${size}&d=mp`;

type GravatarProps = {
  email: string;
  size: number;
  alt?: string;
  title?: string;
  style?: CSSProperties;
};

/**
 * The person's Gravatar, or the generic silhouette while hashing or when they have none.
 */
export const Gravatar = ({ email, size, alt, title, style }: GravatarProps) => {
  const [hash, setHash] = useState<string>();

  useEffect(() => {
    hashEmail(email).then(setHash);
  }, [email]);

  return (
    <img
      src={getUrl({ hash, size })}
      srcSet={`${getUrl({ hash, size: size * 2 })} 2x`}
      width={size}
      height={size}
      alt={alt}
      title={title}
      style={style}
    />
  );
};
